import axios from 'axios'
import { FB_API_URL } from 'lib/env'
import { createError } from 'requests/errors'

export const getCreditRequestList = async (iin) => {
  try {
    const res = await axios.get(FB_API_URL + `/finbroker/credit_request/filter/?offset=0&limit=10&startDate=&endDate=&iin=${iin}&username=&status=all&branchCode=&bankSend=`)
    return res.data
  } catch (e) {
    return createError(e)
  }
}